import React from 'react';
import { ArrowPathIcon, PlusIcon } from '@heroicons/react/24/solid';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onChoice: (choice: 'replace' | 'append') => void;
  title: string;
  itemCount: number;
  itemType: 'nodes' | 'beams';
}

export const CSVImportChoiceDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  onChoice,
  title,
  itemCount,
  itemType
}) => {
  if (!isOpen) return null;

  const handleChoice = (choice: 'replace' | 'append') => {
    onChoice(choice);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">{title}</h2>
          <p className="text-gray-600">
            Ready to import {itemCount} {itemType}. Choose your import method:
          </p>
        </div>

        <div className="space-y-4">
          {/* Replace Option */}
          <button
            onClick={() => handleChoice('replace')}
            className="w-full p-4 border-2 border-red-300 hover:border-red-500 hover:bg-red-50 rounded-lg transition-all duration-200 group"
          >
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <ArrowPathIcon className="h-8 w-8 text-red-600 group-hover:text-red-700" />
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-900 group-hover:text-red-900">
                  Replace
                </div>
                <div className="text-sm text-gray-600 group-hover:text-red-700">
                  Existing {itemType} will be replaced with the imported ones
                </div>
              </div>
            </div>
          </button>

          {/* Append Option */}
          <button
            onClick={() => handleChoice('append')}
            className="w-full p-4 border-2 border-blue-300 hover:border-blue-500 hover:bg-blue-50 rounded-lg transition-all duration-200 group"
          >
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <PlusIcon className="h-8 w-8 text-blue-600 group-hover:text-blue-700" />
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-900 group-hover:text-blue-900">
                  Append
                </div>
                <div className="text-sm text-gray-600 group-hover:text-blue-700">
                  Imported {itemType} will be added to the existing list
                </div>
              </div>
            </div>
          </button>
        </div>

        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
